import { NotificationCenter_Viewed } from '@stashinvest/product-events-typescript';
import type { TrackFn } from 'stash/components/retirement/managed/events';
import type { NotificationCenterTab } from './types';

const TAB_PROPERTY = NotificationCenter_Viewed.v1.Tab;

export function trackNotificationCenterViewed(
	track: TrackFn,
	tab: NotificationCenterTab
): void {
	track(NotificationCenter_Viewed.v1({ tab: TAB_PROPERTY[tab] }));
}
